import { createContext, useState } from 'react';
import { contents } from '../content';

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('en');

  const value = {
    lang,
    setLang,
    content: contents[lang],
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}
